import React from 'react';
import LeaderCard from './LeaderCard';
import { useLanguage } from '../context/LanguageContext';

const LeadershipSection = () => {
  const { t } = useLanguage();
  const leaders = [
    { 
      name: "Le Van Hai", 
      position: t('leadership.haiPos'),
      description: t('leadership.haiDesc'),
      image: `${process.env.PUBLIC_URL || ''}/avata/hai.jpg`
    },
    { 
      name: "Nguyen Xuan Chien", 
      position: t('leadership.chienPos'),
      description: t('leadership.chienDesc'),
      image: `${process.env.PUBLIC_URL || ''}/avata/Chien.jpg`
    },
    { 
      name: "Nguyen Van Thanh", 
      position: t('leadership.thanhPos'),
      description: t('leadership.thanhDesc'),
      image: `${process.env.PUBLIC_URL || ''}/avata/thanh.png`
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-normal text-center text-gray-800 mb-12 fade-in">
          {t('leadership.sectionTitle')}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {leaders.map((leader, index) => (
            <LeaderCard
              key={index}
              name={leader.name}
              position={leader.position}
              description={leader.description}
              image={leader.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
